module.exports = __webpack_public_path__ + "static/img/anxunMobel11.a96b59f2.png";